module.exports = __webpack_public_path__ + "static/media/spring-framework-logo-2.9d950430.jpg";